import { __decorate } from "tslib";
import { property } from 'lit/decorators/property.js';
import { authContext, consumer } from './context';
export const withAuth = (superClass) => {
    class AuthConsumerElement extends superClass {
    }
    __decorate([
        consumer({ context: authContext, subscribe: true }),
        property({ type: Object, attribute: false })
    ], AuthConsumerElement.prototype, "auth", void 0);
    return AuthConsumerElement;
};
//# sourceMappingURL=consumer-mixin.js.map